var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartContracts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 171,
    viewBox: "0 0 194 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_208_311",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 194,
    height: 171
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 171,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_208_311)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddd_208_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.7529 56.1506H117.608V60.5362H73.7529V56.1506ZM73.7529 78.0784H95.9164V82.4639H73.7529V78.0784ZM115.903 67.1145H73.7529V71.5H111.521L115.903 67.1145ZM86.8904 113.36C87.6276 114.206 88.5634 114.854 89.6135 115.249C90.6637 115.643 91.7953 115.77 92.9068 115.619H114.295C114.803 115.619 115.291 115.416 115.651 115.057C116.011 114.697 116.213 114.209 116.213 113.7C116.213 113.191 116.011 112.703 115.651 112.343C115.291 111.983 114.803 111.781 114.295 111.781H92.9068C90.4098 111.737 90.8538 109.569 91.2047 108.898C91.6621 108.11 92.0185 107.267 92.2654 106.39C92.4293 105.684 92.3521 104.944 92.046 104.287C91.74 103.63 91.2228 103.095 90.577 102.766C89.5394 102.299 88.3772 102.184 87.2683 102.44C86.1594 102.696 85.165 103.308 84.4372 104.183C83.4943 105.156 82.1841 106.645 80.9288 108.092C81.7045 105.052 82.7104 101.152 83.6972 97.3474C83.9799 96.4805 83.9236 95.5387 83.5396 94.7117C83.1556 93.8846 82.4724 93.2339 81.6277 92.8905C80.6923 92.5696 79.6699 92.6154 78.7669 93.0188C77.8639 93.4223 77.1476 94.1532 76.7625 95.0641C75.5784 97.3419 66.2043 113.05 66.1111 113.209C65.9819 113.426 65.8965 113.665 65.8599 113.915C65.8233 114.164 65.8362 114.418 65.8978 114.662C65.9594 114.907 66.0685 115.137 66.2189 115.339C66.3693 115.541 66.5581 115.711 66.7744 115.841C67.2113 116.102 67.734 116.178 68.2275 116.054C68.7209 115.93 69.1448 115.614 69.4058 115.177C69.7566 114.588 77.2394 102.054 79.5994 97.8681C77.8233 104.721 75.8662 112.346 75.7511 113.031C75.6215 113.535 75.6604 114.067 75.8618 114.547C76.0633 115.027 76.4162 115.427 76.8667 115.687C77.3684 115.936 77.9387 116.011 78.4876 115.9C79.0365 115.788 79.5328 115.498 79.8982 115.073C80.2435 114.761 80.8904 114.018 82.5213 112.124C84.0408 110.337 85.5971 108.581 87.1891 106.859C87.7867 106.228 88.1485 106.508 87.7976 107.127C87.1113 107.994 86.6663 109.028 86.5074 110.122C86.3486 111.216 86.4817 112.334 86.8931 113.36H86.8904Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddd_208_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.572 93.1401V121.386H62.7891V44.6387H128.572V58.3243L132.218 54.6788C132.779 54.1253 133.394 53.6295 134.054 53.1987V41.8977C134.054 41.1708 133.765 40.4736 133.251 39.9595C132.737 39.4455 132.04 39.1567 131.313 39.1567H60.0481C59.3211 39.1567 58.624 39.4455 58.1099 39.9595C57.5959 40.4736 57.3071 41.1708 57.3071 41.8977V124.127C57.3071 124.854 57.5959 125.551 58.1099 126.065C58.624 126.579 59.3211 126.868 60.0481 126.868H131.313C132.04 126.868 132.737 126.579 133.251 126.065C133.765 125.551 134.054 124.854 134.054 124.127V92.4055C132.373 93.2963 130.429 93.5569 128.572 93.1401Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dddd_208_311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.369 66.1852L143.935 64.7516C144.668 63.7834 145.039 62.5894 144.984 61.3765C144.929 60.1636 144.451 59.0081 143.634 58.1103C142.573 57.1751 141.185 56.6971 139.774 56.7803C138.362 56.8635 137.04 57.5011 136.096 58.5543L101.766 92.8794L99.4713 101.492C99.435 101.604 99.4306 101.725 99.4586 101.84C99.4866 101.955 99.5458 102.06 99.6298 102.143C99.7138 102.227 99.8193 102.285 99.9345 102.312C100.05 102.34 100.17 102.334 100.283 102.297L108.865 99.9758L140.912 67.9284L142.266 69.2852C142.361 69.3796 142.436 69.4918 142.487 69.6152C142.538 69.7387 142.564 69.871 142.564 70.0047C142.564 70.1383 142.538 70.2707 142.487 70.3941C142.436 70.5176 142.361 70.6297 142.266 70.7242L128.789 84.2015C128.378 84.613 128.147 85.1709 128.147 85.7525C128.147 86.3341 128.379 86.8918 128.79 87.3029C129.202 87.714 129.759 87.9448 130.341 87.9446C130.923 87.9443 131.48 87.713 131.891 87.3016L145.369 73.8242C146.382 72.8106 146.951 71.4363 146.951 70.0033C146.951 68.5703 146.382 67.196 145.369 66.1824V66.1852Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.02
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.4983 34.1262H120.664V41.6428H45.4983V34.1262ZM45.4983 71.7091H83.4852V79.2257H45.4983V71.7091ZM117.742 52.9177H45.4983V60.4342H110.23L117.742 52.9177ZM68.0151 132.18C69.2787 133.629 70.8825 134.741 72.6824 135.417C74.4824 136.093 76.422 136.31 78.3269 136.051H114.984C115.856 136.051 116.693 135.704 117.31 135.088C117.926 134.471 118.273 133.635 118.273 132.762C118.273 131.89 117.926 131.054 117.31 130.437C116.693 129.82 115.856 129.474 114.984 129.474H78.3269C74.0472 129.399 74.8082 125.683 75.4095 124.532C76.1935 123.181 76.8044 121.737 77.2276 120.233C77.5085 119.024 77.3761 117.755 76.8516 116.629C76.3271 115.503 75.4407 114.586 74.3337 114.023C72.5554 113.221 70.5634 113.025 68.6629 113.464C66.7623 113.902 65.0579 114.952 63.8105 116.451C62.1945 118.119 59.9489 120.67 57.7973 123.151C59.1268 117.941 60.8509 111.256 62.5421 104.735C63.0268 103.249 62.9303 101.635 62.2721 100.218C61.6139 98.8001 60.443 97.6848 58.9952 97.0963C57.3919 96.5462 55.6396 96.6248 54.0919 97.3162C52.5443 98.0076 51.3166 99.2604 50.6565 100.822C48.6271 104.726 32.5604 131.649 32.4007 131.922C32.1792 132.292 32.0329 132.703 31.9702 133.13C31.9074 133.558 31.9295 133.993 32.0351 134.412C32.1406 134.831 32.3277 135.225 32.5855 135.571C32.8433 135.918 33.1668 136.21 33.5375 136.431C34.2864 136.879 35.1822 137.01 36.028 136.797C36.8738 136.584 37.6002 136.043 38.0475 135.295C38.6488 134.285 51.474 112.801 55.5188 105.628C52.4746 117.372 49.1203 130.442 48.923 131.616C48.7009 132.48 48.7676 133.392 49.1129 134.214C49.4581 135.036 50.063 135.723 50.8351 136.168C51.695 136.595 52.6725 136.723 53.6133 136.532C54.5541 136.342 55.4046 135.844 56.0309 135.116C56.6228 134.581 57.7315 133.307 60.5267 130.061C63.1311 126.998 65.7985 123.989 68.5272 121.037C69.5513 119.956 70.1714 120.435 69.5701 121.497C68.3939 122.983 67.631 124.754 67.3588 126.63C67.0866 128.506 67.3146 130.42 68.0198 132.18H68.0151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.856 102.761V148.68H30.912V23.912H137.856V46.1608L143.783 40.2343C144.695 39.3345 145.695 38.5284 146.768 37.8281V19.456C146.768 18.2742 146.299 17.1408 145.463 16.3051C144.627 15.4695 143.494 15 142.312 15H26.456C25.2742 15 24.1408 15.4695 23.3051 16.3051C22.4695 17.1408 22 18.2742 22 19.456V153.136C22 154.318 22.4695 155.451 23.3051 156.287C24.1408 157.123 25.2742 157.592 26.456 157.592H142.312C143.494 157.592 144.627 157.123 145.463 156.287C146.299 155.451 146.768 154.318 146.768 153.136V101.567C144.035 103.015 140.874 103.439 137.856 102.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.163 58.9406L162.833 56.6101C164.024 55.0361 164.627 53.095 164.537 51.1232C164.448 49.1513 163.671 47.2729 162.342 45.8132C160.618 44.293 158.362 43.5159 156.067 43.6511C153.772 43.7863 151.623 44.8229 150.088 46.5351L94.277 102.338L90.5473 116.338C90.4883 116.522 90.4811 116.718 90.5266 116.905C90.5721 117.092 90.6684 117.262 90.805 117.398C90.9415 117.534 91.113 117.629 91.3003 117.673C91.4876 117.717 91.6835 117.709 91.8663 117.648L105.818 113.874L157.918 61.7746L160.119 63.9804C160.273 64.1339 160.395 64.3162 160.478 64.5169C160.561 64.7176 160.604 64.9328 160.604 65.1501C160.604 65.3673 160.561 65.5825 160.478 65.7832C160.395 65.9839 160.273 66.1662 160.119 66.3198L138.209 88.2299C137.54 88.8988 137.165 89.8058 137.166 90.7514C137.166 91.6969 137.542 92.6036 138.211 93.2719C138.88 93.9402 139.787 94.3154 140.732 94.315C141.678 94.3146 142.585 93.9386 143.253 93.2697L165.163 71.3595C166.81 69.7117 167.735 67.4774 167.735 65.1478C167.735 62.8182 166.81 60.5839 165.163 58.9362V58.9406Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_208_311",
    x: 35.619,
    y: 25.93,
    width: 112.21,
    height: 120.403,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.07931
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.917647 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_208_311"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.15862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.917647 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_208_311",
    result: "effect2_dropShadow_208_311"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.55515
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.917647 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_208_311",
    result: "effect3_dropShadow_208_311"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.1103
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.917647 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_208_311",
    result: "effect4_dropShadow_208_311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_208_311",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddd_208_311",
    x: 13.1008,
    y: -5.04956,
    width: 165.16,
    height: 176.124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5788
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.917647 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_208_311"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.15759
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.917647 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_208_311",
    result: "effect2_dropShadow_208_311"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.0516
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.917647 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_208_311",
    result: "effect3_dropShadow_208_311"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.1031
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.917647 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_208_311",
    result: "effect4_dropShadow_208_311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_208_311",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dddd_208_311",
    x: 75.4952,
    y: 32.8258,
    width: 95.4007,
    height: 93.4491,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.855187
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.917647 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_208_311"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.71037
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.917647 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_208_311",
    result: "effect2_dropShadow_208_311"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.98631
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.917647 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_208_311",
    result: "effect3_dropShadow_208_311"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.9726
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.917647 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_208_311",
    result: "effect4_dropShadow_208_311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_208_311",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartContracts);
export default __webpack_public_path__ + "static/media/smart-contracts.4912e98ba48ad5b65789533111e4bc6b.svg";
export { ForwardRef as ReactComponent };